import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { AuthDialogComponent } from '@x/ecommerce-shop/app/core/auth/components/auth-dialog/auth-dialog.component';
import { AuthState } from '@x/ecommerce-shop/app/core/auth/state/auth.state';
import { ShopStorage } from '@x/ecommerce-shop/app/core/shop-storage/shop-storage.service';
import { AuthorizationHeaderProvider, IAuthorizationHeader } from '@x/ecommerce/shop-client';
import { Observable } from 'rxjs';

export interface AuthDialogData {
  heading?: string;
  message?: string;
  login?: boolean;
  register?: boolean;
  logout?: boolean;
  canClose?: boolean;
  logo?: boolean;
}

export type AuthDialogResponse = 'login' | 'register' | 'logout' | undefined;

@Injectable()
export class AuthService implements AuthorizationHeaderProvider {
  constructor(
    private shopStorage: ShopStorage,
    private matDialog: MatDialog,
    private store: Store,
  ) {}

  get orderAuthHeader(): IAuthorizationHeader | undefined {
    const token = this.shopStorage.orderToken?.token;
    if (!token) return;

    return {
      context: {
        headers: {
          Authorization: token,
        },
      },
    };
  }

  get userAuthHeader(): IAuthorizationHeader | undefined {
    const token = this.shopStorage.userToken?.token;
    if (!token) return;

    return {
      context: {
        headers: {
          Authorization: token,
        },
      },
    };
  }

  get userId(): number | undefined {
    return (
      this.store.selectSnapshot(AuthState.loggedInUser)?.id ?? this.shopStorage.userToken?.userId
    );
  }

  openAuthDialog(data: AuthDialogData): Observable<AuthDialogResponse> {
    return this.matDialog
      .open<AuthDialogComponent, AuthDialogData, AuthDialogResponse>(AuthDialogComponent, {
        data,
        disableClose: data.canClose === false,
        panelClass: 'fullwidth-dialog-mobile',
      })
      .afterClosed();
  }
}
